<template>
  <div>
    <HeaderComp v-if="!route.meta.hideHeader" />
    <RouterView />
    <FooterComp v-if="!route.meta.hideHeader && !uiStore.isPromoMode" />
  </div>
</template>

<script setup>
import HeaderComp from '../pages/HeaderComp.vue'
import FooterComp from '../pages/FooterComp.vue'
import { useRoute } from 'vue-router'
import { useUiStore } from '../stores/useUiStore'

const route = useRoute()
const uiStore = useUiStore()
</script>
